import { render, staticRenderFns } from "./managerBoard.vue?vue&type=template&id=14f20421&scoped=true"
import script from "./managerBoard.vue?vue&type=script&lang=js"
export * from "./managerBoard.vue?vue&type=script&lang=js"
import style0 from "./managerBoard.vue?vue&type=style&index=0&id=14f20421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f20421",
  null
  
)

export default component.exports